// extracted by mini-css-extract-plugin
export default {"gradientButton":"OUiLD0k9"};